// extracted by mini-css-extract-plugin
export default {"home":"index_home__95I8D","content":"index_content__PUkBS","item2":"index_item2__BrNkU","item3":"index_item3__Kvj0i"};